<template>
  <v-dialog v-model="dialog" persistent max-width="500px" transition="dialog-transition">
    <v-card>
      <v-card-title primary-title>
        Assinatura Inválida
      </v-card-title>
      <v-card-text>
        Para prosseguir com o atendimento, é necessário possuir uma assinatura pessoal.
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn small color="primary" @click="redirectToAssinatura">Preencher assinatura</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      reqiured: true
    }
  },
  data() {
    return {
      dialog: true
    }
  },
  methods: {
    redirectToAssinatura() {
      this.$router.push({ path: 'assinatura' })
    }
  }
}
</script>

<style></style>
